import NavBar from "@/components/UI/NavBar";
import CityList from "@/components/UI/CityList";
import ButtonRegister from "@/components/UI/ButtonRegister";
import MyButton from "@/components/UI/MyButton";
import FormCity from "@/components/UI/FormCity";
import InputCity from "@/components/UI/InputCity";
import FilterButton from "@/components/UI/FilterButton";
import ModalProduct from "@/components/UI/ModalProduct";
import ButtonFilter from "@/components/UI/ButtonFilter";
import TabsList from "@/components/UI/TabsList";
import TabsItem from "@/components/UI/TabsItem";
import ModalAuth from "@/components/UI/ModalAuth";
import MyInput from "@/components/UI/MyInput";
import CounterProduct from "@/components/UI/CounterProduct";
import FooterPage from "@/components/UI/FooterPage";
import Carousel from "@/components/UI/Carousel";
import CarouselItem from "@/components/UI/CarouselItem";
import RadioList from "@/components/UI/RadioList";
import RadioListItem from "@/components/UI/RadioListItem";
import DropList from "@/components/UI/DropList";
import DropHistoryOrders from "@/components/UI/DropHistoryOrders";
import IsLoading from "@/components/UI/IsLoading";

export default [
  NavBar,
  CityList,
  ButtonRegister,
  MyButton,
  FormCity,
  InputCity,
  FilterButton,
  ModalProduct,
  ButtonFilter,
  TabsList,
  TabsItem,
  MyInput,
  ModalAuth,
  CounterProduct,
  FooterPage,
  Carousel,
  RadioList,
  RadioListItem,
  CarouselItem,
  DropList,
  DropHistoryOrders,
  IsLoading
];
